import React from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

export default function ReflectAndIntegrate2({ apiData, previewData, reportType, pageNumber }) {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)", }}>
      <HeaderPreview apiData={apiData} />
      <div style={{ padding: '16px 0px', display: 'flex', justifyContent: 'left', alignItems: 'left', }}>
        <div>
          <h2
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontStyle: 'normal',
              fontSize: '14px',
              lineHeight: '18px',
              letterSpacing: '0px',
              color: '#00577D',
              textTransform: 'uppercase',
              marginBottom: '16px',
              marginTop: 0,
            }}
          >
            LIFE INTEGRATION
          </h2>
          <p style={{
            fontFamily: 'Helvetica, sans-serif',
            fontWeight: 400,
            fontSize: '10px',
            lineHeight: '14px',
            color: '#000000',
            letterSpacing: 0,
          }} >Use these 12 quadrant-based questions to deepen your personal insight, coaching conversations, or journaling practice. Focus on one quadrant—or explore them all.</p>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            HEART – Motivation, Values, Relational Insight
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px" }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What do your results reveal about what truly matters to you in your current season?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>How are your priorities aligned—or misaligned—with the way you lead and live?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where might your leadership impact improve by adjusting how you relate to others?</li>
          </ol>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            SOUL – Vision, Purpose, Perspective
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px" }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What long-term outcomes or legacy do your results point you toward?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>How well does your current direction align with your stated values or beliefs?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What perspective shift could help you navigate current complexity more effectively?</li>
          </ol>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            MIND – Strategy, Structure, Decision-Making
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px" }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What decision-making habits or systems need to be refined based on your results?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where is unclear thinking or a lack of structure hindering your leadership?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>How will you prioritize changes that improve clarity, focus, or efficiency?</li>
          </ol>

          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            STRENGTH – Execution, Accountability, Action
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px" }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What specific action will you take based on a key insight from the assessment?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where do you need to increase ownership, follow-through, or consistency?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What measurable result or goal will you commit to over the next 30 days?</li>
          </ol>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
